import React from "react";
import { useTranslation } from "react-i18next";

const Terms = () => {
  const { t } = useTranslation();
  return (
    <main className="page-shell max-w-3xl">
      <p className="eyebrow mb-3">{t("legal.eyebrow")}</p>
      <h1 className="font-serif text-4xl font-bold text-gold-700">{t("legal.termsTitle")}</h1>
      <div className="mt-8 space-y-6 text-sm leading-7 text-gray-600">
        <p>{t("legal.termsIntro")}</p>
        <h2 className="font-serif text-2xl font-bold text-gold-700">{t("legal.communityTitle")}</h2>
        <p>{t("legal.communityText")}</p>
        <h2 className="font-serif text-2xl font-bold text-gold-700">{t("legal.paymentsTitle")}</h2>
        <p>{t("legal.paymentsText")}</p>
      </div>
    </main>
  );
};

export default Terms;
